import React, { FunctionComponent } from 'react';
import useFeatures, { FeatureContext } from '../Features/useFeatures';
import PageLoad from '../Page/PageLoad';

const AuthenticateLaunchDarkly: FunctionComponent = (props) => {
  const features = useFeatures();

  if (!features.isReady) {
    return <PageLoad />;
  }

  return <FeatureContext.Provider {...props} value={features} />;
};

export default AuthenticateLaunchDarkly;
